/* eslint-disable no-redeclare */
import {
  DomainSessionId,
  DomainUserId,
  HealthcareSessionId,
  HealthcareUserId,
  JourneyId,
  PageIdentifier,
  ProductType,
} from '@hc-frontend/core-types';
import { z } from 'zod';

import { Location } from '../lead-session';
import { PartialSurveyAnswers } from '../medicare-advantage-survey-answers';

export const UpdateProspectJourneyParameters = z.object({
  sessionId: HealthcareSessionId,
  userId: HealthcareUserId,
  journeyId: JourneyId,
  productType: ProductType,
  additionalQuestions: PartialSurveyAnswers.optional(),
  location: Location.optional(),
  domainUserId: DomainUserId.optional(),
  domainSessionId: DomainSessionId.optional(),
  standardizedMaterialId: PageIdentifier.optional(),
});

export type UpdateProspectJourneyParameters = z.infer<
  typeof UpdateProspectJourneyParameters
>;
